import { createApp } from 'vue'
import CategoryCard from '~/js/components/categoryCard'
import FTab from '~/js/components/tab'
import { TabItem } from '~/js/models/tabItem'

const CLASS_NAME = 'js-indexCategories'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const dataItemElements = element.getElementsByClassName('js-dataTabItem')
    const tabItems = Array.from(dataItemElements).map((element) => {
      return new TabItem({ title: element.dataset.title }, element.dataset.url)
    })

    const dataCategoriesElements =
      element.getElementsByClassName('js-dataCategories')
    const categories = []
    const footerLinks = []
    Array.from(dataCategoriesElements).forEach((element) => {
      const link = {
        title: element.dataset.title,
        url: element.dataset.url,
        imageUrl: element.dataset.imageUrl,
        noImageUrl: element.dataset.noImageUrl,
        parentIndex: Number(element.dataset.parentIndex),
      }
      if (link.title.includes('すべての')) {
        footerLinks.push(link)
      } else {
        categories.push(link)
      }
    })

    createApp({
      name: 'TemplatesIndexCategories',
      components: {
        CategoryCard,
        FTab,
      },
      data() {
        return {
          categories,
          footerLinks,
          selectedIndex: 0,
          tabItems,
        }
      },
      computed: {
        selectedCategories() {
          return this.categories.filter((category) => {
            return category.parentIndex === this.selectedIndex
          })
        },
        selectedLink() {
          return this.footerLinks.find((footerLink) => {
            return footerLink.parentIndex === this.selectedIndex
          })
        },
      },
      created() {
        this.setSelectedTabItem()
      },
      methods: {
        onTabItemClicked(index) {
          this.selectedIndex = index
          this.setSelectedTabItem()
        },
        setSelectedTabItem() {
          this.tabItems.forEach((item, index) => {
            item.isSelected = index === this.selectedIndex
          })
        },
      },
    }).mount(element)
  })
})
